// PageDescription: 추가 주문 페이지
import DefaultLayout from '@/components/layouts/DefaultLayout';
import AdditionalOrderView from '@/views/additional-order/ui/AdditionalOrderView';

const AdditionalOrderPage = () => {
  return <AdditionalOrderView />;
};

AdditionalOrderPage.Layout = DefaultLayout;

export default AdditionalOrderPage;
